import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useBracket } from './BracketProvider';

export const HeatTabs = ({ setSelectedHeatIndex, selectedHeatIndex }) => {
  const { heatTabs } = useBracket();
  return (
    <Box sx={{ px: 6, mb: 2 }}>
      <Tabs
        value={selectedHeatIndex}
        variant={'scrollable'}
        scrollButtons={false}
        onChange={(_, value) => {
          if (value === 0 || value) {
            setSelectedHeatIndex(value);
          }
        }}
      >
        {heatTabs.map((heatTab, index) => {
          if (!!heatTab) {
            const { name } = heatTab;
            return <Tab value={index} key={name} label={name} />;
          }
        })}
      </Tabs>
    </Box>
  );
};
